import { urlValidator } from './url';
export var getUrlSegementsValidators = function (_a) {
    var url = _a.url;
    return [urlValidator(url)].find(Boolean);
};
//# sourceMappingURL=get-url-segements-validators.js.map